import { Component, OnInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Page } from 'src/app/models/page.model';
import { ShopService } from 'src/app/services/shop.service';

@Component({
  selector: 'app-wp-menu',
  templateUrl: './wp-menu.component.html',
  styleUrls: ['./wp-menu.component.scss']
})
export class WpMenuComponent implements OnInit, OnDestroy {

  pages$: any;
  page: Page = null;
  restaurant$: any;
  restaurantId: any;
  loading = true;

  constructor(
    private shop: ShopService,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.restaurant$ = this.shop.restaurant.subscribe((res) => {
      if (res) {
        if (res.restaurantId) {
          const r = this.shop.restaurant.value.restaurantId;
          this.restaurantId = r;
          const l = this.translate.currentLang;

          const slugMap: Record<number, { de: string; en: string }> = {
            1: { de: "menu-kreuzplatz", en: "menu-kreuzplatz-en" },
            3: { de: "menu-europaallee", en: "menu-europaallee-en" },
            4: { de: "menu-kesselhaus", en: "menu-kesselhaus-en" },
            5: { de: "menu-andermatt", en: "menu-andermatt-en" },
          };

          this.pages$ = this.shop.pages.subscribe((pages) => {
            this.page = pages.find((c) => [slugMap[r]?.[l]].includes(c.slug));
            this.loading = false;
          });
        }
      }
    });
  }

  ngOnDestroy() {
    this.restaurant$.unsubscribe();
  }
}
